import { useEffect } from "react";

const useInfiniteScroll = ({
  containerRef,
  page,
  setPage,
  currentCount,
  totalCount,
  isFetching,
}) =>
  useEffect(() => {
    if (currentCount >= totalCount) {
      // Nothing more to load
      return;
    }

    if (isFetching) {
      // Wait for the current request to finish
      return;
    }

    const container = containerRef.current;
    if (!container) {
      // Container is not displayed
      return;
    }

    const nextPageNumber = page + 1;

    if (container.scrollHeight <= container.clientHeight) {
      // Container is not scrollable but has room for more content
      setPage(nextPageNumber);
      return;
    }

    const onScroll = () => {
      const scrolledToBottom =
        container.scrollHeight - container.scrollTop === container.clientHeight;

      if (scrolledToBottom) {
        setPage(nextPageNumber);
      }
    };

    container.addEventListener("scroll", onScroll);

    return function () {
      container.removeEventListener("scroll", onScroll);
    };
  }, [containerRef, page, setPage, currentCount, totalCount, isFetching]);

export default useInfiniteScroll;
